import { Component, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import _ from 'lodash'

import { RequestModel } from "../../shared/interface/response"
import { CalendarLocale } from '../../shared/static/calendar-locale';
import { MessageComponent } from '../../shared/component/message/message.component';
import { ChecklistResponseQueryComponent } from '../../shared/component/checklist-response-filter-query/checklist-response-filter-query.component';

@Component({
	selector: 'app-question-unconformity-response',
	templateUrl: './question-uncoformity-response.html',
	styleUrls: ['./question-uncoformity-response.css'],
})
export class QuestionUnconformityResponseComponent extends ChecklistResponseQueryComponent {
	@ViewChild(MessageComponent) message: MessageComponent;

	formatNumber = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 });
	calendarLocale = CalendarLocale;

	readonly alignCenter = { 'text-align': 'center' };
	readonly maxSize = { width: '100%'	};

	responses = [] as any;

	criticalityColors = [
		'blue', // 0
		'yellow', // 1
		'red', // 2
		'black', // 3
	]

	criticalityDescription = [
		'low_criticality',
    'medium_criticality',
    'high_criticality',
    'no_tolerance',
	]

	totalRecords = { count: 0, checklistResponseCount: 0, questUncResponseCount: 0 };
	answerId: number = 0;
	loading: boolean;

	filter(newEvent) {
		this.responses = [];

		this.queryData = this.updateFilterData(newEvent, this.queryData);

		// not used in this component, cleaning cache to previne data loss
		// this.rawUsers = this.queryData.raw_users || [];
		this.queryData.raw_users = [];

		// disabling lazy loading without filter params
		if (this.needWaitForFilter()) return;

		if (!this.loading) {
			this.loading = true;

			this.questUncRespService.getUnconformities(this.queryData)
      .pipe(take(1)).finally(() => this.loading = false )
			.subscribe((response: any) => {
				this.message.success(this.translate('loaded_data'));

				this.totalRecords.count = response.count;
				this.totalRecords.questUncResponseCount = response.questUncResponseCount;
				this.totalRecords.checklistResponseCount = response.checklistResponseCount;

				this.responses = response.rows;
				this.responses = this.responses.sort((a, b) => b.quantityCount - a.quantityCount);

			}, ({ error }) => this.errorHandler(error));
		}
	}

	needWaitForFilter = () => !(this.queryData && this.queryData.init_date);
}

// ERR_SPDNMAS
// Supplied parameters do not match any signature of call target
// - The issue trigger when an parameter is requires in super() or is invalid.



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/report/question-uncoformity-response/question-uncoformity-response.component.ts